import React, { useState, useRef, useEffect } from "react";
import './CxDetailscroll.css';
import DynamicTable from "../DynamicTable";
import selectedIcon from './selectedIcon.svg';
import unselectedIcon from './unselectedIcon.svg';
import prev from './prev.svg';
import next from './next.svg';

const CxDetailscroll = (props) => {
    const { item, showMaximumChat } = props;

    let data = item?.text_data?.data[0];
    let valueArr = item?.text_data?.data[0]?.value;
    const [selectedBox, setSelectedBox] = useState(null);

    // References for carousel and arrows
    const carouselRef = useRef(null);
    const [showPrevArrow, setShowPrevArrow] = useState(false);
    const [showNextArrow, setShowNextArrow] = useState(true);

    const formatCxDetails = (a) => {
        let parts = a.split('<br>');
        let result = {};
        parts.forEach(part => {
            if (part.trim() === '') return;
            let [key, value] = part.split(':');
            if (value === undefined) {
                result['Descriptor'] = key.trim();
            } else {
                result[key.trim()] = value.trim();
            }
        });
        return result;
    };

    // Create a new array with formatted objects
    const formattedArray = item?.text_data?.data?.map(item => formatCxDetails(item.name));
    
    useEffect(() => {
        if (formattedArray?.length === 1) {
            setSelectedBox(0);
            props?.setErrors((prevErrors) => ({
                ...prevErrors,
                [props?.index]: {
                    key1: item?.text_data?.data[0]?.value,
                    displayName: item?.text_data?.data[0]?.value,
                },
            }));
            localStorage.setItem("inputBoxValue", JSON.stringify({
                key1: item?.text_data?.data[0]?.value
            }));
        }
    }, [formattedArray?.length]);
    
    const res = formattedArray?.length > 1;

    const handleBoxClick = (index) => {
        setSelectedBox(index);
        props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]:{ key1: item?.text_data?.data[index]?.value , displayName: item?.text_data?.data[index]?.value  } ,  // Update only the specific index
        }));
        localStorage.setItem("inputBoxValue", JSON.stringify({ key1: item?.text_data?.data[index]?.value }));
    };

    // Scroll handler
    const handleScroll = () => {
        const carousel = carouselRef.current;
        const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
        setShowPrevArrow(carousel.scrollLeft > 0);
        setShowNextArrow(carousel.scrollLeft < maxScrollLeft);
    };

    // Arrow click handlers
    const scrollCarousel = (direction) => {
        const carousel = carouselRef.current;
        carousel.scrollBy({ left: direction === 'next' ? 200 : -200, behavior: 'smooth' });
    };

    useEffect(() => {
        const carousel = carouselRef.current;
        carousel.addEventListener('scroll', handleScroll);
        return () => carousel.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="carousel-container">
            {showPrevArrow && formattedArray?.length > 1 && (
                <img src={prev} alt="Previous" className="arrow prev" onClick={() => scrollCarousel('prev')} />
            )}
            {showNextArrow && formattedArray?.length > 1 && (
                <img src={next} alt="Next" className="arrow next" onClick={() => scrollCarousel('next')} />
            )}

            <div className="carousel" ref={carouselRef}>
                {formattedArray?.map((_, index) => {
                    const isSelected = selectedBox === index;
                    const isFirstBox = index === 0; // Check if it's the first box
                    return (
                        <div
                            key={index}
                            style={{ minWidth: showMaximumChat ? '50%' : '95%', height : '100%' }}
                            className={`boxx ${isSelected ? 'selected' : ''} action-tab error-${props?.index} `} // Apply 'bounce' to the first box
                            onClick={() => handleBoxClick(index)}
                        >
                            <div className="box-item">
                                {formattedArray.length > 0 && <img
                                    src={isSelected ? selectedIcon : unselectedIcon}
                                    alt={isSelected ? "Selected" : "Unselected"}
                                    style={{ left: '45%' }}
                                    className="selection-icon"
                                />}
                                <DynamicTable obj={formattedArray[index]} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CxDetailscroll;
